export function primaryCategory(post) {
  if (!post) return;

  const filteredCategory = post.categories.edges.filter((category) => category.isPrimary === true);
  return filteredCategory[0] ? filteredCategory[0].node.name : 'Uncategorized';
}

export function filterPostsByCategory(posts, category) {
  return posts.filter((post) =>
    post.categories.edges.map((cat) => cat.node.name).includes(category),
  );
}

export function filterOutPostsByCategory(posts, category) {
  return posts.filter(
    (post) => !post.categories.edges.map((cat) => cat.node.name).includes(category),
  );
}

export function filterSinglePostByCategory(post, category) {
  return post.categories.edges.map((cat) => cat.node.name).includes(category);
}
